import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { DECRYPT_VAULT_FORM_ID } from '@/entity/constants';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import type { DecryptFormData } from './decrypt-form.types';
export type DecryptFormProps = {
  children: React.ReactNode;
};
const DecryptForm = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const decryptControls = useDecryptControls();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: {
        fields: [],
        documentKinds: []
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formMethods = useForm(t1);
  let t2;
  if ($[1] !== decryptControls.decryptedDocumentKinds || $[2] !== decryptControls.decryptedFields || $[3] !== decryptControls.step || $[4] !== formMethods) {
    t2 = () => {
      if (decryptControls.step === "idle") {
        formMethods.setValue("fields", decryptControls.decryptedFields);
        formMethods.setValue("documentKinds", decryptControls.decryptedDocumentKinds);
      }
    };
    $[1] = decryptControls.decryptedDocumentKinds;
    $[2] = decryptControls.decryptedFields;
    $[3] = decryptControls.step;
    $[4] = formMethods;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = decryptControls.step === "idle";
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t2, t4);
  let t5;
  if ($[8] !== decryptControls || $[9] !== formMethods) {
    t5 = () => {
      decryptControls.reset();
      formMethods.reset();
    };
    $[8] = decryptControls;
    $[9] = formMethods;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== children || $[13] !== formMethods) {
    t7 = <form id={DECRYPT_VAULT_FORM_ID}><FormProvider {...formMethods}>{children}</FormProvider></form>;
    $[12] = children;
    $[13] = formMethods;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default DecryptForm;